export const useEventUtil = {
  /**
   * 防抖
   * @param {Function} fn 需要防抖的函数
   * @param {Number} delay 延迟时间
   * @returns {Function} 防抖处理后的函数
   */
  debounce: (fn, delay = 300) => {
    let timer = null
    return function(...args) {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => fn.apply(this, args), delay)
    }
  },

  /**
   * 节流
   * @param {Function} fn 需要节流的函数
   * @param {Number} delay 延迟时间
   * @returns {Function} 节流处理后的函数
   */
  throttle: (fn, delay = 300) => {
    let lastTime = 0
    return function(...args) {
      const now = Date.now()
      if (now - lastTime >= delay) {
        lastTime = now
        fn.apply(this, args)
      }
    }
  }
}
